module.exports = __webpack_public_path__ + "static/small-garden_ceramic_repurposed-fur_found-objects_freshwater-pearls-5cb50f86e77e28b1a3c93cff43c968ef.jpg";